/* eslint-disable no-shadow */
/**
 * Search Filter Box types
 */
export enum SearchFilterEnum {
  square = 'square',
  oval = 'oval',
}
